import styled from 'styled-components';
import {tabletMedia} from '../../../../globalVariables/GlobalVariables';

export const wrap = styled.div`
    display: flex;
    flex-direction: column;
`;

export const contentArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
    padding: var(--space-lg) 0;
`;

export const toolbarRow = styled.div`
    display: none;

    ${tabletMedia} {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--space-sm);
    }
`;
